'use client';

import { c as _c } from "react/compiler-runtime";
import { NotificationBanner } from './notification-banner';
import { useSystemNotifications } from '../model/use-system-notifications';

/**
 * The banner list itself, split out of `SystemNotificationHost` so the host can
 * hold it back until the browser is idle. Everything this costs on mount, the
 * notifications query and its dismiss mutation, lives here.
 */
export function SystemNotificationBanners() {
  const $ = _c(3);
  const {
    notifications,
    dismissNotification
  } = useSystemNotifications();
  let t0;
  if ($[0] !== dismissNotification || $[1] !== notifications) {
    t0 = <NotificationBanner notifications={notifications} onDismiss={dismissNotification} variant="overlay" />;
    $[0] = dismissNotification;
    $[1] = notifications;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}